import { Box, Button, NoticeBox } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  FixedBreakInputs,
  FlexibleBreakInputs,
  SemiFlexibleBreakInputs,
} from 'modules/shift_management/components/ShiftManagement/PlannedBreaks/FormInputs'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'
import { DayConfigurationWithBreaksForm } from 'modules/work_schedules/hooks/useDayConfigurations'

import BreakDetailsIcon from './BreakDetailsIcon'

interface Props {
  form: DayConfigurationWithBreaksForm
  breakForm: PlannedBreakForm
  validationParams: {
    startAt?: moment.Moment
    endAt?: moment.Moment
    duration?: number
  }
  onDeleteBreak: (dayConfiguration: DayConfigurationWithBreaksForm, form: PlannedBreakForm) => void
}
const WorkScheduleBreakInputs = ({ form, breakForm, validationParams, onDeleteBreak }: Props) => {
  const error = breakForm.validationError(validationParams)
  const { dayConfiguration } = form
  const width = dayConfiguration.isFixed ? 's360' : 's300'

  if (breakForm.isArchived) {
    return (
      <Box flexDirection="row" gap="s16">
        <NoticeBox
          message={i18n.t('shift_management.planned_breaks.archived.warning_schedule')}
          borderRadius={{ all: 'abs008' }}
        />
        <Box paddingTop="s6">
          <Button
            type="secondary"
            onClick={() => onDeleteBreak(form, breakForm)}
            iconName="delete"
          />
        </Box>
      </Box>
    )
  }

  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Box paddingTop="s8">
        <BreakDetailsIcon form={breakForm} />
      </Box>
      <Box width={width}>
        <Box flexDirection="row" gap="s16">
          {/* Use showNotice once the refactor is done with the new layout of breaks */}
          {breakForm.isFlexible && <FlexibleBreakInputs form={breakForm} error={error} />}
          {breakForm.isFixed && <FixedBreakInputs form={breakForm} error={error} />}
          {breakForm.isSemiFlexible && <SemiFlexibleBreakInputs form={breakForm} error={error} />}

          <Box paddingTop="s6">
            <Button
              type="secondary"
              onClick={() => onDeleteBreak(form, breakForm)}
              iconName="delete"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default WorkScheduleBreakInputs
